import { makeAutoObservable } from "mobx";
import apiHandler from "../handlers/ApiHandler";

class LocationStore {
  locations = [];
  isLoading = false;
  error = null;

  constructor() {
    makeAutoObservable(this);
  }

  async fetchLocations() {
    this.isLoading = true;
    this.error = null;
    try {
      const response = await apiHandler.get("/api/locations");
      this.locations = response;
    } catch (error) {
      this.error = error.toString();
      console.error("Error fetching locations:", error);
    } finally {
      this.isLoading = false;
    }
  }

  async createLocation(newLocation) {
    try {
      const response = await apiHandler.post("/api/locations", newLocation);
      this.locations.push(response);
      return response.id;
    } catch (error) {
      this.error = error.toString();
      console.error("Error creating location:", error);
    }
  }

  async updateLocation(locationId, locationData) {
    try {
      const response = await apiHandler.put(
        `/api/locations/${locationId}`,
        locationData
      );
      const index = this.locations.findIndex((loc) => loc.id === locationId);
      if (index !== -1) {
        this.locations[index] = response;
      }
    } catch (error) {
      this.error = error.toString();
      console.error(`Error updating location with ID ${locationId}:`, error);
    }
  }

  async deleteLocation(locationId) {
    try {
      await apiHandler.delete(`/api/locations/${locationId}`);
      this.locations = this.locations.filter((loc) => loc.id !== locationId);
    } catch (error) {
      this.error = error.toString();
      console.error(`Error deleting location with ID ${locationId}:`, error);
    }
  }

  get defaultLocationId() {
    const defaultLoc = this.locations.find(
      (l) => l.city.toLowerCase() === "default city"
    );
    return defaultLoc?.id ?? null;
  }
}

const locationStore = new LocationStore();
export default locationStore;
